import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import { HEADER_DESKTOP_MEDIA_QUERY } from '../../constants';
import { getOrderedCategories } from '../../services/category/selector';

import CategoriesSubNavComponent from './CategoriesSubNavComponent';

import './AllCategoriesMenuComponent.scss';

class AllCategoriesMenuComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
        this.buttonRef = React.createRef();
    }

    toggleMenu = () => this.setState(prevState => ({ isOpen: !prevState.isOpen }));

    closeMenu = () => this.setState({ isOpen: false });

    // Ferme le menu quand le focus quitte le groupe bouton + sous-menu.
    handleBlur = e => {
        const next = e.relatedTarget;
        if (next && next.closest && next.closest('.header-categories')) {
            return;
        }
        this.closeMenu();
    };

    // Un clic dans le vide du sous-menu ne doit pas le fermer : on empêche le
    // mousedown de déplacer le focus (donc pas de blur). La navigation des
    // liens n'en dépend pas, le clic les déclenche sans focus préalable.
    handleSubNavMouseDown = e => {
        e.preventDefault();
    };

    // Escape ferme le menu ouvert et rend le focus au bouton déclencheur.
    handleKeyDown = e => {
        if (e.key === 'Escape' && this.state.isOpen) {
            this.closeMenu();
            if (this.buttonRef.current) {
                this.buttonRef.current.focus();
            }
        }
    };

    render() {
        const { categories, i18n, i18nAccessibility, compact } = this.props;
        const { isOpen } = this.state;

        return (
            <MediaQuery query={HEADER_DESKTOP_MEDIA_QUERY}>
                {matches =>
                    matches && (
                        <div
                            className="header-categories"
                            onBlur={this.handleBlur}
                            onKeyDown={this.handleKeyDown}>
                            <button
                                type="button"
                                id="header-categories-bt"
                                className={`bt header-categories-bt${compact ? ' compact' : ''}`}
                                ref={this.buttonRef}
                                aria-haspopup="true"
                                aria-expanded={isOpen}
                                aria-controls="sous-menu-rubriques-categories"
                                onClick={this.toggleMenu}>
                                <span className="header-categories-bt-label">
                                    {i18n.ALL_CATEGORIES}
                                </span>
                                <span className="triangle" aria-hidden="true" />
                            </button>
                            <CategoriesSubNavComponent
                                categories={categories}
                                id="sous-menu-rubriques-categories"
                                open={isOpen}
                                ariaLabel={i18nAccessibility.NAV_SUBMENU_ALL_CATEGORIES_LABEL}
                                isAllOffers
                                disableHover
                                onCategoryClick={this.closeMenu}
                                onMouseDown={this.handleSubNavMouseDown}
                            />
                        </div>
                    )
                }
            </MediaQuery>
        );
    }
}

AllCategoriesMenuComponent.propTypes = {
    categories: PropTypes.array.isRequired,
    i18n: PropTypes.object.isRequired,
    i18nAccessibility: PropTypes.object.isRequired,
    compact: PropTypes.bool
};

const mapStateToProps = state => ({
    categories: getOrderedCategories(state),
    i18n: state.i18n.feature.header.menu,
    i18nAccessibility: state.i18n.feature.header.ACCESSIBILITY
});

export default connect(mapStateToProps)(AllCategoriesMenuComponent);



// WEBPACK FOOTER //
// ./src/components/header/AllCategoriesMenuComponent.js